import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../utils/axios";


export const fetchModules = createAsyncThunk(
    'module/fetchModules',
    async(_, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get('v1/accounts/modules/');
            console.log(response.data);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
); 

const moduleSlice = createSlice({
    name: 'module',
    initialState: {
        modules: [],
        moduleLoading: false,
        moduleError: null
    },
    reducers: {
        clearModule: (state) => {
            state.moduleLoading = false;
            state.moduleError = null;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchModules.pending, (state) => {
                state.moduleLoading = true;
                state.moduleError = null;
            })
            .addCase(fetchModules.fulfilled, (state, action) => {
                state.moduleLoading = false;
                state.modules = action.payload;
            })
            .addCase(fetchModules.rejected, (state, action) => {
                state.moduleLoading = false;
                state.moduleError = action.payload?.message || "Cannot fetch roles";
            })
    }
});

export const { clearModule } = moduleSlice.actions;
export default moduleSlice;